<div data-cy="video-player" class="brightcove" [id]="componentId"></div>
